import { Form, Input } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { ButtonCommon } from 'src/common'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import {
	onCreateDictWordTypes,
	onUpdateDictWordTypes,
} from 'src/redux/dict/dict.action'
import { selectCurrentDictWordType } from 'src/redux/dict/dict.selector'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'
const FormEditWordType = () => {
	const dispatch = useAppDispatch()
	const dictWordType = useAppSelector(selectCurrentDictWordType)
	const [form] = Form.useForm()
	const inputRef = useRef()
	const [isSubmitLoading, setIsSubmitLoading] = useState()

	useEffect(() => {
		inputRef.current.focus()
	}, [])

	useEffect(() => {
		if (dictWordType?.id) {
			form.setFieldsValue(dictWordType)
		}
	}, [dictWordType, form])

	const handleSubmit = async () => {
		const values = await form.validateFields()
		const type = values.type.trim()
		if (type) {
			setIsSubmitLoading(true)
			if (dictWordType?.id) {
				dispatch(
					onUpdateDictWordTypes(
						{
							id: dictWordType.id,
							...values,
						},
						handleSubmitCb
					)
				)
			} else {
				dispatch(onCreateDictWordTypes(values, handleSubmitCb))
			}
		} else {
			showMessageError('Please enter type')
		}
	}

	const handleSubmitCb = (isSuccess, rs) => {
		setIsSubmitLoading(false)
		if (isSuccess) {
			showMessageSuccess()
		} else {
			showMessageError(rs)
		}
	}
	return (
		<Form form={form} initialValues={dictWordType}>
			<Form.Item
				label="Type"
				name="type"
				rules={[
					{
						required: true,
						message: 'Please enter type',
					},
				]}
			>
				<Input ref={inputRef} placeholder={`Enter type`} />
			</Form.Item>

			<Form.Item label="Language code" name="isTypeLanguage">
				<Input placeholder={`Enter language code`} />
			</Form.Item>

			<div className="u-row-right">
				<ButtonCommon
					onClick={handleSubmit}
					type="primary"
					loading={isSubmitLoading}
				>
					Save
				</ButtonCommon>
			</div>
		</Form>
	)
}

export default FormEditWordType
